<template>
  <div class="fila-atendimento">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Sala de atendimento</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atenção, no momento você está em atendimento
          </h5>
        </div>
      </v-container>
    </div>
    <div class="pa-3">
      <div>
        <v-btn class="mb-3" dense color="primary" @click="dialog = true">
          <v-icon size="18">mdi-account-outline</v-icon>
          Dados pessoais
        </v-btn>
      </div>
      <div class="whereby">
        <whereby-embed @participant_join="onParticipantJoin" v-if="roomUrl" class="whereby-embed" audio="on" video="on"
          :room="roomUrl"></whereby-embed>
      </div>
    </div>
    <FormDadosAtendimento @close="dialog = false" :closable="true" v-if="dialog" @dados-confirmados="enterOnQueue" />
  </div>
</template>
<script>
import meetingService from '@/services/meeting'
import FormDadosAtendimento from '../AtendimentoVirtual/FormDadosAtendimento.vue'

export default {
  name: 'SalaAtendimento',
  components: {
    FormDadosAtendimento
  },
  data() {
    return {
      idAsoMeetingRoom: null,
      idMeetingRoom: null,
      tokenAtendimento: null,
      roomUrl: null,
      dialog: false,
      userHasJoined: false,
      timer: null
    }
  },
  methods: {
    async enterOnMeetingRoom() {
      if (this.idAsoMeetingRoom && this.idMeetingRoom) {
        try {
          this.loading = true
          const { data } = await meetingService.enterOnRoom(
            this.idAsoMeetingRoom,
            this.idMeetingRoom,
            this.tokenAtendimento
          )
          this.roomUrl = data.meetingRoomUrl
          this.timer = setInterval(this.roomStatus, 5000)
        } catch ({ response }) {
          console.log(response)
          this.$showErrorMessage(response.data.message)
          this.$router.push({ name: 'dashboard' })
        } finally {
          this.loading = false
        }
      } else {
        this.$showErrorMessage('Não é possivel entrar na sala de atendimento')
      }
    },
    async roomStatus() {
      const { data } = await meetingService.checkAppointmentStatus(this.idAsoMeetingRoom)
      if (data.status === 'finalizado') {
        this.$showSuccessMessage('Atendimento finalizado com sucesso')
        this.$router.push({
          name: 'sucesso-atendimento',
          query: { id: this.idAsoMeetingRoom }
        })
      } else if (data.status !== 'em_atendimento') {
        this.$showErrorMessage('Não foi possivel continar o atendimento no momento')
        this.$router.push({
          name: 'dashboard'
        })
      }
    },
    onParticipantJoin() {
      this.userHasJoined = true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    if (!this.userHasJoined) {
      meetingService.userHasNotJoined(
        {
          idAsoMeetingRoom: this.idAsoMeetingRoom,
          device: navigator.userAgent
        }
      )
    }
  },
  mounted() {
    this.enterOnMeetingRoom()
  },
  created() {
    this.idMeetingRoom = this.$route.query.room
    this.idAsoMeetingRoom = this.$route.query.id
    this.tokenAtendimento = this.$route.query.token
  }
}
</script>
<style scoped>
.whereby {
  overflow-y: hidden;
}

.whereby-embed {
  height: 70vh !important;
  margin-top: -35px;
  /* border-radius: 10px; */
}
</style>
